export function buildSummaryRow(alerts, trends, forecasts) {
  const picked = [];
  for (const a of alerts) { if (picked.length < 2) picked.push(a); }
  for (const f of forecasts) { if (picked.length < 3) picked.push(f); }
  for (const t of trends) { if (picked.length < 3) picked.push(t); }
  return picked;
}
